module.exports = __webpack_public_path__ + "img/wechartCode.a2fffc9a.jpg";